import { useState } from "react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { Mail, MapPin, Phone } from "lucide-react";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/public/contact", form);
      toast.success(data.message);
      setForm({ name: "", email: "", message: "" });
    } catch (err) { toast.error(apiError(err.response?.data?.detail)); }
    setLoading(false);
  };
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-16 grid lg:grid-cols-2 gap-12">
      <div>
        <h1 className="text-4xl font-extrabold tracking-tight text-navy">Get in touch</h1>
        <p className="mt-4 text-lg text-slate-600">Questions about plans, the website add-on or Amden Services? Send us a message.</p>
        <img src="https://images.pexels.com/photos/18973734/pexels-photo-18973734.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" alt="Modern glass office buildings in Dublin's docklands, Ireland" loading="lazy" className="mt-6 rounded-2xl shadow-lg ring-1 ring-slate-200 w-full h-56 object-cover" />
        <div className="mt-8 space-y-4 text-slate-700">
          <p className="flex items-center gap-3"><Mail className="text-blue-accent" size={20} /> info@amden.ie</p>
          <p className="flex items-center gap-3"><Phone className="text-blue-accent" size={20} /> 046 927 4424</p>
          <p className="flex items-center gap-3"><MapPin className="text-blue-accent" size={20} /> Kells, Co. Meath</p>
        </div>
      </div>
      <form onSubmit={submit} className="amden-card p-7 space-y-4" data-testid="contact-form">
        <div>
          <label className="text-sm font-medium text-slate-700">Your name</label>
          <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="contact-name"
            className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2.5 focus:ring-2 focus:ring-blue-500 outline-none" />
        </div>
        <div>
          <label className="text-sm font-medium text-slate-700">Email</label>
          <input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="contact-email"
            className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2.5 focus:ring-2 focus:ring-blue-500 outline-none" />
        </div>
        <div>
          <label className="text-sm font-medium text-slate-700">Message</label>
          <textarea required rows={5} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} data-testid="contact-message"
            className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2.5 focus:ring-2 focus:ring-blue-500 outline-none" />
        </div>
        <button disabled={loading} data-testid="contact-submit" className="w-full px-5 py-3 rounded-xl bg-navy hover:bg-slate-800 text-white font-semibold transition-colors disabled:opacity-60">
          {loading ? "Sending…" : "Send message"}
        </button>
      </form>
    </div>
  );
}
